import { render, staticRenderFns } from "./Http403.vue?vue&type=template&id=54e2dd5a&scoped=true"
import script from "./Http403.vue?vue&type=script&lang=ts"
export * from "./Http403.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e2dd5a",
  null
  
)

export default component.exports